import React, { useState } from 'react';

import FormSelectStatic from 'modules/transactions/components/FormSelectStatic';
import TransactionHistory from './TransactionHistory';
import UpgradeHistory from './UpgradeHistory';
import RateHistory from './RateHistory';
import Verification from './Verification';

const options = [
  // { id: 0, label: 'Upgrade History', value: 'upgrade' },
  { id: 1, label: 'Transaction History', value: 'transaction' },
  // { id: 2, label: 'Rate History', value: 'rate' },
  // { id: 3, label: 'Verification History', value: 'verification' },
];

const History = () => {
  const [filter, setFilter] = useState({
    type: { label: 'Transaction History', value: 'transaction' },
  });

  return (
    <div className="h-full flex flex-col space-y-6">
      <FormSelectStatic
        name="type"
        data={options}
        value={filter?.type}
        onChange={setFilter}
        withClear={false}
      />
      {filter?.type?.value === 'upgrade' && <UpgradeHistory />}
      {filter?.type?.value === 'transaction' && <TransactionHistory />}
      {filter?.type?.value === 'rate' && <RateHistory />}
      {filter?.type?.value === 'verification' && <Verification />}
    </div>
  );
};

export default History;
